import type { FileSource } from '@personly/libs-types';

export type SrcSet = {
  src: string;
  width: number;
  height: number;
  alt: string;
};

const makeFileSrcSet = (
  fileSource: FileSource,
  desiredWidth?: number
): SrcSet => {
  const { metadata, url, alt } = fileSource;
  const ratio = parseInt(metadata.height, 10) / parseInt(metadata.width, 10);
  const width = desiredWidth || parseInt(metadata.width, 10);
  const height = Math.round(ratio * width);
  return { src: url, height, width, alt };
};

const makeFileSrcSets = (
  fileSources: Record<string, FileSource>,
  width?: number
) =>
  Object.keys(fileSources).reduce<Record<string, SrcSet>>(
    (acc, schemeHandle) => ({
      ...acc,
      [schemeHandle]: makeFileSrcSet(fileSources[schemeHandle], width),
    }),
    {}
  );

export { makeFileSrcSets };
